export const SET_REPORT = 'SET_REPORT'
export const SET_REPORT_RESULT = 'SET_REPORT_RESULT'
